import { Colors } from "./Colors";
import styled from "styled-components";

export const MainHeaderTheme = styled.div`
  color: ${Colors.mainColor};
  border-bottom: solid 2px lightgray;
  text-align: left;
  padding-bottom: 10px;
  margin-bottom: 30px;
  font-size: 25px;
`;

const size = {
  large: 30,
  medium: 20,
  small: 16,
  xsmall: 12,
}

const primaryFontFamily = "Roboto";

const titleFonts = {
  fontFamily: primaryFontFamily,
  textAlign: "left",
  fontSize: "30px"
};

const headerFont = {
  color: Colors.mainColor,
  borderBottom: "solid 2px lightgray",
  textAlign: "left",
  paddingBottom: "10px",
  marginBottom: "30px",
  fontSize: "25px"
};

const errorFont = {
  color: "red",
  fontSize: "12.5px",
  textAlign: "left",
  marginTop: "2%"
};

const fontSize = {
  large: 30,
  medium: 20,
  small: 16,
  tiny: 10,
};

const paragraphFont = {
  fontFamily: primaryFontFamily,
  fontSize: fontSize.small
}

const errorMessage = {
  color: "red"
};

export const Fonts = {
  headerFont,
  errorFont,
  fontSize,
  errorMessage,
  titleFonts,
  size,
  primaryFontFamily,
  paragraphFont
};
